module.exports = __webpack_public_path__ + "img/pic_333832_1.adabc979.jpg";